import { Route, Routes } from 'react-router-dom';

import { customerRoutes } from 'noddi-util';
import { Recall } from '.';
import { MaintenanceContent } from '../../components/SystemDownTimeBlocker';
import { getNoddiRemoteConfig } from '../../utils/remoteConfigSetup';
import { RecallAddress } from './Address';
import { RecallSummary } from './Summary';
import { RecallTimeWindowPicker } from './TimeWindowPicker/TimeWindowPicker';

export function RecallRouter() {
  const maintenanceScreenBooking = getNoddiRemoteConfig('maintenanceScreenBooking');

  if (maintenanceScreenBooking?.shouldShow) {
    return <MaintenanceContent maintenanceScreen={maintenanceScreenBooking} />;
  }

  return (
    <Routes>
      <Route path={customerRoutes.recallLandingPage.getBasePath()} element={<Recall />} />

      <Route path={customerRoutes.recallSummary.getBasePath()} element={<RecallSummary />} />

      <Route path={customerRoutes.recallTimeWindowPicker.getBasePath()} element={<RecallTimeWindowPicker />} />

      <Route path={customerRoutes.recallAddress.getBasePath()} element={<RecallAddress />} />
    </Routes>
  );
}
